import $ from 'jquery';
import { displayBackgroundManager } from '../../displayBackgroundManager';

export const onClickBackgroundTag = (event) => {
  const sidebarCurrentBackgroundTagItemId = $(event.currentTarget).data(
    'backgrounds-item-id'
  );
  displayBackgroundManager(sidebarCurrentBackgroundTagItemId);
};
